var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriberPlanLifetime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 75,
    viewBox: "0 0 120 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00390625,
    width: 120,
    height: 75,
    rx: 8,
    fill: "url(#paint0_linear_13551_218174)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13551_218174",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 76
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.00390625,
    width: 120,
    height: 75,
    rx: 8,
    fill: "#ED713C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13551_218174)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.5,
    cy: 80.5,
    rx: 70.5,
    ry: 49.5,
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13551_218174",
    x1: 108.706,
    y1: 77.4363,
    x2: 53.9765,
    y2: 4.71419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D881DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A84C7D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriberPlanLifetime);
export default __webpack_public_path__ + "static/media/subscriber-plan-lifetime.3b3b3d86a27a99ba6699ed94d38ec434.svg";
export { ForwardRef as ReactComponent };